import { useSelector } from 'react-redux';
import React from 'react';

import { useLabels, useSitemap, usePrefs } from 'wsm-common-data';

import Location from '../components/Location';
import { getLocationAttributes } from '../utils/utility';

import '../global-sass/main.scss';
import { useWidgetInfo } from '../features/widgetInfo';

const locationStatusDisplayList = ['IN_TRANSIT', 'RESERVED', 'OFF_LOT'];

const Widget = () => {
	const prefs = usePrefs();
	const { alwaysDisplayWidget, checkAvailabilityWidget, overrideLocation } =
		prefs;
	const location = useSelector((state) => state.location);
	const widgetInfo = useWidgetInfo();
	const labels = useLabels();
	const sitemap = useSitemap();

	let shouldDisplay = false;
	if (
		location &&
		(alwaysDisplayWidget === 'true' ||
			locationStatusDisplayList.find((x) => x === location.status))
	) {
		shouldDisplay = true;
	}
	if (
		overrideLocation === 'true' &&
		alwaysDisplayWidget !== 'true' &&
		location.status === 'OFF_LOT'
	) {
		shouldDisplay = false;
	}
	if (shouldDisplay) {
		return (
			<Location
				displayObj={getLocationAttributes(
					location,
					checkAvailabilityWidget,
					labels,
					sitemap,
					overrideLocation,
					widgetInfo,
					prefs
				)}
			/>
		);
	}
	return null;
};

export default Widget;
